<template>
    <div class="date-time-picker columns">
        <div 
            class="column"
            :class="{
                'is-half is-flex date-part': !onlyDate,
                'is-full is-flex is-flex-centered': onlyDate
            }"
        >
            <b-datepicker 
                v-model="date"
                :min-date="minDate"
                :max-date="maxDate"
                :years-range="[-1, 3]"
                :day-names="days"
                :month-names="months"
                @input="changeDate"
                inline
            />
        </div>
        <div class="column is-half is-flex time-part" v-if="!onlyDate">
            <b-clockpicker
                v-model="time"
                class="ml-4"
                :hour-format="hourFormat"
                @input="changeHour"
                inline
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        value: {
            type: Date,
            default: new Date()
        },
        minDate: {
            type: Date,
            default: null
        },
        maxDate: {
            type: Date,
            default: null
        },
        onlyDate: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            date: this.value,
            time: this.value,
            result: this.value,
            days: [
                this.$t('dom'),
                this.$t('seg'),
                this.$t('ter'),
                this.$t('qua'),
                this.$t('qui'),
                this.$t('sex'),
                this.$t('sab'),
            ],
            months: [
                this.$t('january'),
                this.$t('february'),
                this.$t('march'),
                this.$t('april'),
                this.$t('may'),
                this.$t('june'),
                this.$t('july'),
                this.$t('august'),
                this.$t('september'),
                this.$t('october'),
                this.$t('november'),
                this.$t('december')
            ],
            hourFormat: this.$t('hour-format')
        }
    },
    created () {
        addEventListener('change-locale', this.updateLocale);
        this.updateLocale();
    },
    beforeDestroy () {
        removeEventListener('change-locale', this.updateLocale);
    },
    methods: {
        changeHour(h) {
            this.result.setHours(h.getHours());
            this.result.setMinutes(h.getMinutes());
            this.result.setSeconds(0);
            this.emitChanges();
        },
        changeDate(d) {
            this.result.setDate(d.getDate());
            this.result.setMonth(d.getMonth());
            this.result.setFullYear(d.getFullYear());
            this.emitChanges();
        },
        emitChanges() {
            this.$emit('input', this.result);
        },
        updateLocale() {
            /*  O ML já mudou quando chegar aqui, então refaz o array da
                mesma maneira que o create que já pega as strings atualizadas. */
            this.days = [
                this.$t('dom'),
                this.$t('seg'),
                this.$t('ter'),
                this.$t('qua'),
                this.$t('qui'),
                this.$t('sex'),
                this.$t('sab'),
            ];

            this.months = [
                this.$t('january'),
                this.$t('february'),
                this.$t('march'),
                this.$t('april'),
                this.$t('may'),
                this.$t('june'),
                this.$t('july'),
                this.$t('august'),
                this.$t('september'),
                this.$t('october'),
                this.$t('november'),
                this.$t('december')
            ];

            this.hourFormat = this.$t('hour-format');
        }
    },
    watch: {
        value(nd) {
            if (nd instanceof Date) {
                this.date = nd;
                this.time = nd;
                this.result = nd;
            }
        }
    },
}
</script>

<style lang="scss" scoped>
.date-time-picker {
    @include mq-min-desktop {
        .date-part {
            justify-content: flex-end;
        }

        .time-part {
            justify-content: flex-start;
        }
    }

    @include mq-max-desktop {
        .date-part, .time-part {
            justify-content: center;
        }
    }
}
</style>